export class UserFilterModel {
  searchKeyword?: string;
  paginationCriteria?: PaginationCriteria = new PaginationCriteria();
  sortCriteria?: SortCriteria = new SortCriteria();
  filterCriteria?: FilterCriteria = new FilterCriteria();
}

export class PaginationCriteria {
  offset: number;
  itemsPerPage: number;
}

export class SortCriteria {
  field: string;
  direction: string;
}

export class FilterCriteria {
  targetGroupValue: string;
  active: boolean;
  confirmed: boolean;
  customerAdmin: boolean;
  countryCode: string;
}
